import React from 'react';
import PdfPreviewLogin from 'components/pdf/PdfPreviewLogin';
import { EpdLinks } from 'routes/EpdRoutes';

const DynamicFormRegistrationCertificatePdfPreview: React.FunctionComponent = () => (
  <PdfPreviewLogin buildAuthRoute={EpdLinks.dynamicFormRegistrationCertificatePdfPreviewAuth} />
);

export default DynamicFormRegistrationCertificatePdfPreview;
